import { render, staticRenderFns } from "./ContactAdd.vue?vue&type=template&id=282072fa"
import script from "./ContactAdd.vue?vue&type=script&lang=js"
export * from "./ContactAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports